import { TApi } from './types';
import { auth } from './auth';
import { gpsr } from './gpsr';

const api: TApi = {
	auth,
	gpsr,
};

export { api };
